// extracted by mini-css-extract-plugin
export default {"navbar":"Navbar_navbar__TtfUc","logo":"Navbar_logo__QimrM","navLinks":"Navbar_navLinks__jLp9I","navItem":"Navbar_navItem__P3Bg6"};